import { RenderItemProps } from './types'
import { View, Text } from '@/components'
import { formatDateLocalized, variantProvider } from '@/app'
import { TextBubble } from '../atoms/TextBubble'
import { DebugItem } from './shared'

export const FeedTextAnswer = (props: RenderItemProps) => {
  const { item } = props

  const creationDate = formatDateLocalized(new Date(item.created_datetime), 'learn.stories.date_format')

  // const promptDivRef = useRef<HTMLDivElement>(null)
  // const answerDivRef = useRef<HTMLDivElement>(null)

  // const isPromptAnswer = item.type === 'text_answer' && item?.prompt

  // const feedItemHeight = useMemo(() => {
  //   if (IS_SSR) return 0
  //   return (window.innerHeight - 120)
  // }, [])

  // const pushAmount = useMemo(() => {
  //   if (!isPromptAnswer || !promptDivRef.current || !answerDivRef.current) return 0

  //   const promptHeight = promptDivRef.current.getBoundingClientRect().height
  //   const answerHeight = answerDivRef.current.getBoundingClientRect().height
  //   const spacing = 48

  //   const overlayBottom = promptHeight + spacing
  //   const bubbleStart = (feedItemHeight - answerHeight) / 2
  //   const overlap = overlayBottom - bubbleStart
  //   return overlap > 0 ? overlayBottom : 0
  // }, [promptDivRef.current, answerDivRef.current, isPromptAnswer])

  if (!item?.prompt && !item.post) return null

  return (
    <View variants={['fullWidth', 'column', 'gap:2']} style={styles.wrapper}>
      <DebugItem {...props} />
      
      <TextBubble
        title={item?.prompt?.title}
        description={item?.prompt?.description}
        icon={'prompt'}
        style={styles.wrapperPrompt}
      />
      
      <TextBubble
        header={<Text text={creationDate} variants={['p4', 'marginBottom:2']} />}
        title={item?.post?.title}
        description={item?.post?.description}
        lesson={item?.post?.lesson}
        icon={'clipboard-pen'}
      >
        <View variants={['row', 'marginTop:2', 'gap:0.5']}>
          <Text text={'Answer by'} variants={['p4', 'color:headlines', 'color:neutral5']} />
          <Text text={` ${item?.profile?.display_name}`} variants={['p4', 'color:headlines', 'bold', 'color:neutral5']} />
        </View>
      </TextBubble>
    </View>
  )
}

const styles = variantProvider.createComponentStyle(theme => ({
  wrapper: {
    overflowY: 'auto', 
    zIndex: 1,
    ...theme.spacing.paddingHorizontal(2),
    [theme.media.down('small')]: {
      ...theme.spacing.paddingHorizontal(4),
    }
  },
  wrapperPrompt: {
    backgroundColor: theme.colors.prompt,
    ...theme.border.primary3(theme.values.borderWidth.large),
  },
}), true)